import { Component } from '@angular/core';
import { NgIf } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import {
  CustomModalOptions,
  ModalAbstractComponent
} from '@bling-fe/shared/modals/base-modal';
import { VideoModalComponent } from '../video-modal/video-modal.component';

/**
 * Plays a recording of a document list. The same player and the same way out
 * as a video, but a recording needs no screen, so it is a sheet like the
 * recorder that made it.
 */
@Component({
  selector: 'fl-audio-modal',
  templateUrl: './audio-modal.component.html',
  styleUrls: ['./audio-modal.component.scss'],
  imports: [NgIf, IonicModule, TranslateModule],
  providers: [
    { provide: ModalAbstractComponent, useExisting: AudioModalComponent }
  ]
})
export class AudioModalComponent extends VideoModalComponent {
  public static override modalOptions: CustomModalOptions = {
    cssClass: 'audio-modal auto-height bottom-sheet-modal'
  };
}
